<template>
    <div class="container-fluid">
        <nav v-if="for_book">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link :to="booksPath">小説管理</router-link></li>
                <li class="breadcrumb-item"><router-link :to="`/mypage/book/${$route.params.book_id}/sections/`">本文一覧</router-link></li>
                <li class="breadcrumb-item">小説背景</li>
            </ol>
        </nav>
        <nav v-else>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item" v-if="for_portal">ポータル背景設定</li>
                <li class="breadcrumb-item" v-else>本棚背景設定</li>
            </ol>
        </nav>
        <div class="container">
            <legend v-if="book.id">
                {{book.title}}
            </legend>
            <div class="text-muted small p-2 my-2" v-if="for_book">
                小説の背景画像を設定します。<br>
                背景画像はURLで設定でき、最大 {{$store.state.max_background}} 枚追加することができます。
                追加された背景画像は小説の背景として表示され、複数枚ある場合は定期的に切り替わります。
                <div v-if="book.is_long">
                    小説の背景はその小説専用です。本棚の背景が設定されている場合でも、小説の背景が優先的に表示されます。
                </div>
                <div v-else>
                    短編作品に多くの背景を設定しても、読了するまでにすべての背景を表示できないことがあります。
                </div>
            </div>
            <div class="text-muted small p-2 my-2" v-else>
                貸し本棚の
                <span v-if="for_portal">ポータル</span>
                <span v-else>本棚</span>
                背景画像を設定します。<br>
                背景画像はURLで設定でき、最大 {{$store.state.max_background}} 枚追加することができます。
                追加された背景画像は
                <span v-if="for_portal">ポータル</span>
                <span v-else>本棚</span>
                の背景として表示され、複数枚ある場合は定期的に切り替わります。
                <span v-if="for_portal">
                    ポータルの背景画像はユーザー専用です。他の人には見えません。
                </span>
                <span v-else>
                    本棚の背景画像は本棚専用です。本棚を訪れた人に表示されます。
                </span>
            </div>

            <div class="d-flex justify-content-end my-4">
                <div>
                    <button type="button" class="btn btn-outline-primary" :disabled="backgrounds && backgrounds.length >= $store.state.max_background" @click="showEditor()">
                        <i class="fas fa-plus"></i>
                        <span v-if="for_book">小説</span>
                        <span v-else-if="for_portal">ポータル</span>
                        <span v-else>本棚</span>
                        背景画像追加
                    </button>
                </div>
            </div>

            <div class="d-flex justify-content-center flex-wrap" v-if="backgrounds.length">
                <div class="card bg-card m-2" v-for="v in backgrounds" :key="v.id">
                    <div class="img-column">
                        <img :src="v.picture.thumb_url" class="mx-auto d-block cover" v-if="v.picture" />
                        <img :src="v.url" class="mx-auto d-block cover" v-else />
                    </div>
                    <div class="card-footer text-right">
                        <button type="button" class="btn btn-outline-danger btn-sm" @click="remove(v)">
                            <i class="fas fa-times-circle"></i>
                            削除
                        </button>
                    </div>
                </div>
            </div>
            <div class="nothing" v-else>
                <span v-if="for_book">小説</span>
                <span v-else-if="for_portal">ポータル</span>
                <span v-else>本棚</span>
                背景画像はありません。
            </div>
        </div>
        <background-editor
            @load="load"
            :for_portal="for_portal"
            :book_id="$route.params.book_id"></background-editor>
    </div>
</template>

<style scoped lang="scss">
.cover {
    object-fit: cover;
    height: 100%;
    width: 83px;
    position: relative;
}
.bg-card {
    width: 213px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    .img-column {
        background-color: black;
        position: relative;
        height: 300px;
        .cover {
            object-fit: cover;
            width: 213px;
            height: 300px;
        }
    }
}
</style>

<script>
import backgroundEditor from "./backgroundEditor.vue";
export default {
    components: {
        backgroundEditor
    },
    data() {
        return {
            backgrounds: [],
            book: {},
            curr: 0,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/backgrounds/get", {params: {
                is_portal: this.$route.path.match(/portal/) ? 1 : 0,
                book_id: this.$route.params.book_id
            }}).then(res => {
                this.backgrounds = res.data.backgrounds;
                this.curr = res.data.curr;
            }).catch(err => { alert.err(err.response) });
            if (this.$route.params.book_id) {
                axios.get("/mypage/book/get", {params: {id: this.$route.params.book_id}}).then(res => {
                    this.book = res.data;
                }).catch(err => { alert.err(err.response) });
            }
        },
        showEditor() {
            $("#background-editor").modal();
        },
        remove(v) {
            Swal.fire({
                title: "背景画像削除",
                text: "背景画像を削除します。\nよろしいですか？",
                html: `以下の画像を削除します。<div><img src="${v.url}" class="img-fluid img-thumbnail"></div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/background/remove", {id: v.id}).then(res => {
                        alert.msg("背景画像を削除しました。");
                        this.$store.state.backgroundCallback(true);
                        this.load();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
    },
    computed: {
        for_portal() {
            return this.$route.path.match(/portal/) ? 1 : 0;
        },
        for_book() {
            return this.$route.params.book_id ? 1 : 0;
        },
        booksPath() {
            if (this.book?.is_hidden === 3) {
                return "/mypage/books/pending";
            } else if (this.book?.property?.is_finished) {
                return "/mypage/books/finished";
            }
            return "/mypage/books";
        },
    },
    mounted() {
        this.load();
    }
}
</script>

